import React, { useEffect, useState } from "react";

import {
  Box,
  Tabs,
  Tab,
  TextField,
  Typography,
  CircularProgress,
} from "@material-ui/core";

import { useStyles } from "./styles";
import { ListUsersPending } from "./ListUsersPending";
import { ListUsersApproved } from "./ListUsersApproved";
import { ListUsersReproved } from "./ListUsersReproved";
import apiV2 from "../../../api/api-client-v2";
import { toast } from "react-toastify";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";

const filterStatusOption = [
  'pending',
  'approved',
  'rejected'
]

const userTypes = [
  {value: 'client', label: 'Cliente'},
  { value: 'transporter', label: 'Transportadora'}
]

export const ApproveUsersComponent = () => {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(false);
  const [tabPanelActive, setTabPanelActive] = useState(0);
  const [branches, setBranches] = useState([]);
  const [users, setUsers] = useState([]);
  const [filterBranch, setFilterBranch] = useState(null);
  const [filterUser, setFilterUser] = useState('');
  const [countChangeUser, setCountChangeUser] = useState(0);
  const [filterUserType, setFilterUserType] = useState(null);


  const handleChangeTabPanel = (_, newValue) => {
    setTabPanelActive(newValue);
  };

  useEffect(() => {
    if (branches.length < 1) {
      apiV2
      .get("branches")
      .then((response) => {
        setBranches([...response?.data]);
      })
      .catch(() => {
        toast.error("Erro ao buscar filiais!");
      });
    }
  }, [branches])

  const getUsersSignups = (urlWithFilters) => {
    return apiV2.get(`users/signups?${urlWithFilters}`)
      .then((resp) => {
        setUsers(resp.data?.items)
      })
      .catch((error) => {
        toast.error(error?.data?.message ?? 'Houve um erro ao buscar os cadastros')
      })
  }

  useEffect(() => {
    setIsLoading(true)

    const filterStatusQuery = `filter[status]=${filterStatusOption[tabPanelActive]}`;
    const filterBranchQuery = filterBranch?.id ? `&filter[branch_id]=${filterBranch.id}` : ''
    const filterUserQuery = filterUser ? `&filter[email]=${filterUser}` : ''
    const filterUserTypeQuery = filterUserType?.value ? `&filter[user_type]=${filterUserType.value}` : ''

    const urlWithFilters = `${filterStatusQuery}${filterBranchQuery && filterBranchQuery}${filterUserQuery && filterUserQuery}${filterUserTypeQuery && filterUserTypeQuery}`

    getUsersSignups(urlWithFilters)
      .finally(() => {
        setIsLoading(false)
      })

  }, [tabPanelActive, filterBranch, filterUserType, countChangeUser]) //eslint-disable-line

  return (
    <Box className={classes.root}>
      <Box className={classes.filter}>
        <Autocomplete
          id="branches-slt"
          name="branches"
          data-cy="branches-slt"
          noOptionsText="Nenhuma filial encontrada"
          value={filterBranch}
          onChange={(_, newValue) => setFilterBranch(newValue)}
          options={branches}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Selecione uma Filial"
              variant="outlined"
            />
          )}
        />
        <Autocomplete
          id="branches-slt"
          name="branches"
          data-cy="branches-slt"
          noOptionsText="Nenhuma filial encontrada"
          value={filterUserType}
          onChange={(_, newValue) => setFilterUserType(newValue)}
          options={userTypes}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Selecione o tipo de usuário"
              variant="outlined"
            />
          )}
        />
        <TextField
          variant="outlined"
          type="search"
          value={filterUser}
          onChange={(e) => {
            setFilterUser(e.target.value)
            if (e.target.value === '') setCountChangeUser(0)
          }}
          onKeyUp={(e) => {
            e.preventDefault()
            if (e.key === 'Enter') {
              setCountChangeUser(previewState => previewState + 1)
            }
          }}
          placeholder="Filtrar por e-mail"
        />
      </Box>
      <Tabs value={tabPanelActive} onChange={handleChangeTabPanel} className={classes.tabs}>
        <Tab
          label={
            <Typography className={classes.tabLabel}>
              Pendentes
            </Typography>
          }
        />
        <Tab
          label={
            <Typography className={classes.tabLabel}>
              Aprovados
            </Typography>
          }
        />
        <Tab
          label={
            <Typography className={classes.tabLabel}>
              Reprovados
            </Typography>
          }
        />
      </Tabs>
      {isLoading ?  (
        <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', padding: '30px' }}>
          <CircularProgress />
        </Box>
      ) : ''}
      {tabPanelActive === 0 && !isLoading && <ListUsersPending setCountChangeUser={setCountChangeUser} users={users} />}
      {tabPanelActive === 1 && !isLoading && <ListUsersApproved users={users} />}
      {tabPanelActive === 2 && !isLoading && <ListUsersReproved setCountChangeUser={setCountChangeUser} users={users} />}
    </Box>
  );
};
